module.exports = __webpack_public_path__ + "static/media/mobileBackground.846a4ecb.svg";